module.exports = __webpack_public_path__ + "static/media/tif.f784a5bf.svg";